import React from "react";
import {
  Modal,
  Pressable,
  SafeAreaView,
  ScrollView,
  Text,
  View,
} from "react-native";
import constants from "@/config/constants";
import styles from "./legalTermsStyle";
import { useGlobal } from "@/Components/Context/globalContext";
import Markdown from "react-native-markdown-display";

const ModalCookies = (
  modalVisibleCookies: boolean,
  setModalVisibleCookies: any,
) => {
  const { textRecurs, projecte, __ } = useGlobal();

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={modalVisibleCookies}
      onRequestClose={() => setModalVisibleCookies(!modalVisibleCookies)}
    >
      <View style={styles.modalContainer}>
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View
              style={{
                flex: 0,
                flexDirection: "row",
                alignItems: "flex-start",
              }}
            >
              <Text
                style={{
                  color: constants.colorText,
                  fontWeight: "700",
                  fontSize: 24,
                  lineHeight: 28.8,
                }}
              >
                {" "}
                {textRecurs("aviso_legal")}
              </Text>
            </View>
            <SafeAreaView style={styles.containerScrollView}>
              <ScrollView style={styles.scrollView}>
                <Markdown>{__(projecte, "avis_legal") || " "}</Markdown>
              </ScrollView>
            </SafeAreaView>
            <Pressable
              style={[
                styles.btnDarkGreen,
                { backgroundColor: projecte.color_principal },
              ]}
              onPress={() => setModalVisibleCookies(false)}
            >
              <Text style={styles.btnDarkGreenText}>
                {" "}
                {textRecurs("onboarding_aceptar")}
              </Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ModalCookies;
